import { render, staticRenderFns } from "./PolicyPaymentDialog.vue?vue&type=template&id=cd91b36c&scoped=true&"
import script from "./PolicyPaymentDialog.vue?vue&type=script&lang=ts&"
export * from "./PolicyPaymentDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyPaymentDialog.vue?vue&type=style&index=0&id=cd91b36c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd91b36c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
